(function () {
    'use strict';
    angular.module('emarket.store').directive('emStoreProduct', function () {
        return {
            scope: {
                product: '=',
                size: '=',
                direction: '=?'
            },
            templateUrl: function(element, attr) {
                var template = 'store/store-product/store-product.tpl.html';
                if(attr.direction === 'horizontal') {
                    template = 'store/store-product/store.product.horizontal.tpl.html';
                }
                return template;
            }

        };
    });
}());
